import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { Fido2Service } from '../../service/fido2.service';
import { IError, IFido2Payload, IFriendlyNamePayload } from '../../model/fido2.model';
import { distinctUntilChanged, take, takeUntil } from 'rxjs/operators';
import { ActivatedRoute } from '@angular/router';
import { AutoDestroy } from 'src/app/decorator/auto-destroy.decorator';
import { BehaviorSubject, Subject } from 'rxjs';
import { IEnrolledState, IMFAConfigureResponseData } from '../../../shared/model/IMfa.model';

@Component({
  selector: 'verification-enroll-fido2',
  templateUrl: './enroll-fido2.component.html',
  styleUrls: ['./enroll-fido2.component.scss'],
})
export class EnrollFido2Component implements OnInit {
  @Input() track_id!:string;
  @Output() checkFidoStatus = new EventEmitter();
  // rxjs subject to handle the component destroy
  @AutoDestroy destroy$: Subject<boolean> = new Subject<boolean>();
  errorState$ = new BehaviorSubject(<IError>{});
  errorFriendlyName$ = new BehaviorSubject('');
  successState$ = new BehaviorSubject<IMFAConfigureResponseData>({});
  fidoEnrolledResponse: any = {};
  friendlyName: string = '';

  skipBtnOptions = {
    color: 'accent',
    text: 'SUGGESTED_VERIFICATION_METHOD.SKIP',
    alignment: 'right',
    type: 'proceed',
    underline: 'none',
    for: 'cidaasSubmitBtn',
    translateArgs: {},
    style: 'secondary',
  };

  continueBtnOptions = {
    color: 'accent',
    text: 'SUGGESTED_VERIFICATION_METHOD.CONTINUE',
    alignment: 'right',
    type: 'proceed',
    underline: 'none',
    for: 'cidaasSubmitBtn',
    translateArgs: {},
  };

  displayNameInput = {
    label: 'SUGGESTED_VERIFICATION_METHOD.ENROLLMENT.DISPLAY_NAME.LABEL',
    placeholder: 'SUGGESTED_VERIFICATION_METHOD.ENROLLMENT.DISPLAY_NAME.LABEL',
    type: 'text',
    hint: 'SUGGESTED_VERIFICATION_METHOD.ENROLLMENT.DISPLAY_NAME.HINT',
    value: '',
  };

  /**
   *
   * enrollment status
   *
   * initiated
   * processing
   * completed
   * error
   *
   *
   */

  constructor(private _fido: Fido2Service, private _route: ActivatedRoute) {}

  ngOnInit(): void {
    this._route.queryParams.pipe(takeUntil(this.destroy$), distinctUntilChanged(), take(1)).subscribe((q) => {
      //resetting the status
      this.successState$.next({});
      this.errorState$.next(<IError>{});

      this._fido
        .initiateFido2(q.track_id, q.sub)
        .then((res) => {
          this.fidoEnrolledResponse = res;
          this.successState$.next(res);
        })
        .catch((err: IError) => {
          this.errorState$.next(err);
        });
    });
  }

  _fidoEnrollmentStatus = (status: IEnrolledState) => {
    this.checkFidoStatus.emit(status);
  };

  _setDisplayName = (e) => {
    this.friendlyName = e;
  };

  _saveFriendlyName = () => {
    let payload: IFriendlyNamePayload = {};
    payload.device_id = this.fidoEnrolledResponse?.device_id ? this.fidoEnrolledResponse?.device_id : '';
    payload.friendly_name = this.friendlyName ? this.friendlyName : this.fidoEnrolledResponse?.friendly_name;
    payload.id = this.fidoEnrolledResponse?.id ? this.fidoEnrolledResponse?.id : '';
    payload.ph_id = this.fidoEnrolledResponse?.ph_id ? this.fidoEnrolledResponse?.ph_id : '';
    payload.sub = this.fidoEnrolledResponse?.sub ? this.fidoEnrolledResponse?.sub : '';
    const track_id = this._route.snapshot.queryParams?.track_id;
    this._fido._saveFriendlyName(payload, track_id, 'FIDO2').subscribe(
      (res) => {
        const status: any = {
          status: 'completed',
          data: this.fidoEnrolledResponse,
        };
        this.checkFidoStatus.emit(status);
      },
      (error) => {
        this.errorFriendlyName$.next(error);
      }
    );
  };

  _skipFriendlyName = () => {
    const status: any = {
      status: 'completed',
      data: this.fidoEnrolledResponse,
    };
    this.checkFidoStatus.emit(status);
  };

  // cancel fido enrolment
  _cancelFidoEnrolment = () =>{
    this.checkFidoStatus.emit(false);
  }
}
